import { render, staticRenderFns } from "./DashboardCollectionTile.vue?vue&type=template&id=1a2b7af7&scoped=true&"
import script from "./DashboardCollectionTile.vue?vue&type=script&lang=ts&"
export * from "./DashboardCollectionTile.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardCollectionTile.vue?vue&type=style&index=0&id=1a2b7af7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2b7af7",
  null
  
)

export default component.exports